export const MEMBERSHIP_OVERLAY_STEPS = {
  selectPlan: 'selectPlan',
  authentication: 'authentication',
  payment: 'payment',
  returnToReservation: 'returnToReservation',
};
